module.exports = __webpack_public_path__ + "img/categorie-huitres-creuses-famille-boutrais.b4e307a3.jpg";